import {
  ServiceRequestTaskCardDisplayVariant,
  ServiceRequestTaskProps,
} from '../../../types';
import { ServiceRequestTaskComplianceCardPreview } from './ServiceRequestTaskComplianceCardPreview';
import { ServiceRequestTaskSalesTaxFilingCardPreview } from './ServiceRequestTaskSalesTaxFilingCardPreview';

interface ServiceRequestTaskPreviewProps {
  task: ServiceRequestTaskProps['task'];
  config: ServiceRequestTaskProps['config'];
  state: ServiceRequestTaskProps['state'];
  context: ServiceRequestTaskProps['context'];
}

export const ServiceRequestTaskPreview = (
  props: ServiceRequestTaskPreviewProps
) => {
  const { context, task, config, state } = props;

  switch (context.variant) {
    case ServiceRequestTaskCardDisplayVariant.ONLY_ACTION_BUTTON:
      return (
        <div className="flex items-center gap-md">
          {config.getStateConfig(state).actions}
        </div>
      );

    case ServiceRequestTaskCardDisplayVariant.COMPLIANCE_TASK_PREVIEW:
      return (
        <ServiceRequestTaskComplianceCardPreview
          task={task}
          config={config}
          state={state}
          complianceItem={context.serviceRequest.complianceItem}
          context={context}
        />
      );

    case ServiceRequestTaskCardDisplayVariant.SALES_TAX_FILING_TASK_PREVIEW:
      return (
        <ServiceRequestTaskSalesTaxFilingCardPreview
          task={task}
          config={config}
          state={state}
          context={context}
        />
      );

    default:
      return null;
  }
};
